/**
 * Produces the BeginEndDateFilter needed for filter requests for date ranges
 * @param {} dateObj
 * @returns
 */
export const toDateRangeFilter = (dateObj) => {
	if (!dateObj?.startDate && !dateObj?.endDate) return undefined;

	return {
		Begin_Date: dateObj.startDate,
		End_Date: dateObj.endDate,
	};
};
